import '../navigation/tab';
import './account-status';
import { AccountStatus } from './account-status';
const Modal = require('../ui/modal');

const markup = `<db:profile>
	<div data-id='features'>
		<db:tab name='Account Status' data-id='account' data-ignore='1' noroute=1>
			<db:accountstatus data-id='content'></db:accountstatus>
		</db:tab>
	</div>
</db:profile>`;

export default DomClass(markup, function() {
	Modal.call(this);

	on(this, 'open').then(() => {
		this.style = `
			width: min(30rem, 90vw);
			border-color: darkgreen;
		`;
		this.content = AccountStatus();
	});

	on(this, 'close').then(() => {
		this.account.select();
	});

	this.account.select();

	document.body.appendChild(this);
	this.close();

});
